
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { City } from '../../../models/tables/address/city';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';

@Injectable()
export class CityEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    city: City;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService,
        
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCity()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCity(): Promise<any> {
        return new Promise((resolve, reject) => {
           let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.city = data;
                this.onDataChanged.next(this.city);
                resolve(this.city);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            } else {
                this.gw.get('city/wAll/' + this.routeParams.id).subscribe((city: City ) => {
                    this.city = city;
                    this.onDataChanged.next(this.city);
                    resolve(city);
                }, reject);
            }
        });
    }

    insert(city): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('city/', city).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(city): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('city/', city).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(city): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('city/' + city.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): City {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
